// removed by extract-text-webpack-plugin
module.exports = {"hidden":"teHNW","visuallyhidden":"_2xvyr","hide-text":"_2LvKt","center":"Gdy8P","noprint":"_1dRUi","root":"_22rwD","enabledOnMobile":"_1heUO","userDescription":"_3V4Q-"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/LoginButton.scss
 ** module id = 448
 ** module chunks = 0
 **/